import "./InvoiceTable.css";
import { Form } from "react-bootstrap";
import { FaQuestionCircle, FaSwimmingPool } from "react-icons/fa";
import { TbCoins, TbTruckDelivery } from "react-icons/tb";
import CommonUtils from "../../../utils/common";

const InvoiceTableRow = ({ invoice, singleSelectHandler }) => {

    const UTILS = new CommonUtils();

    const iconSize = "30";
    var icon = <FaQuestionCircle />;
    var invoiceType = "Unbekannt";
    var downloadType = "Unknown";
    var invoiceDate = "";
    const anlageNum = invoice.x_anlage_id.length > 0 ? invoice.x_anlage_id[1].split('_')[0].replace('000', '') : ""
    var brutto = "";
    var isDownloaded = UTILS.checkUncheckIcons(invoice.x_datum_downloaded !== "False");

    const hasSecondFile = invoice.x_file_abrechnung2_name && invoice.x_file_abrechnung2_name !== "False";
    const hasMahnungFile = invoice.x_file_mahnung_name && invoice.x_file_mahnung_name !== "False";
    const hasStornoFile = invoice.x_file_stornorechnung_name && invoice.x_file_stornorechnung_name !== "False";


    if (invoice.x_file_poolrechnung_name) {
        icon =  <FaSwimmingPool size={iconSize} className="text-energo" />;
        invoiceType = `${invoice.x_rechnungsart} ENERGO`; 
        downloadType = 'poolrechnung';
        invoiceDate = UTILS.dateToEuFormat(invoice.x_rechnungsdatum);
        brutto = invoice.x_poolbeitrag_summe_lastschrift.toFixed(2);
    }
    else if (invoice.x_file_abrechnung_name) {
        icon =  <TbTruckDelivery size={iconSize} className="text-primary" />;
        invoiceDate = UTILS.dateToEuFormat(invoice.x_eingangsdatum);
        if (invoice.x_is_final_invoice && invoice.x_is_final_invoice === true) invoiceType = 'Endrechnung Energie';
        else invoiceType = 'Abrechnung Energie'

        if (!hasMahnungFile && !hasStornoFile) {
            brutto = Number(invoice.x_rechnungssumme_brutto).toFixed(2);
        }
        downloadType = 'abrechnung';
    } else if (invoice.x_file_vorschreibung_name) {
        icon = <TbCoins size={iconSize} className="text-warning" />;
        invoiceType = 'Vorschreibung Energie';
        invoiceDate = UTILS.dateToEuFormat(invoice.create_date);
        brutto = Number(invoice.x_teilvorschreibung_brutto).toFixed(2);
        downloadType = 'vorschreibung';
    }
    //height: 20px; margin-top: -5px; margin-left: 10px; border-left: 1px solid rgb(13, 110, 253); border-bottom: 1px solid rgb(13, 110, 253);
    return (
        <tr>
            <td><Form.Check onChange={() => singleSelectHandler(`${downloadType}:${invoice.id}`)} className="invoice-checkbox" type="checkbox" id={`${downloadType}:${invoice.id}`} /></td>
            <td>
                {icon}
                {hasSecondFile && <div style={{marginTop: -12, marginLeft: 15, height: 20, borderLeft: "1px solid black", borderBottom: "1px solid black"}}></div>}
                {hasMahnungFile && <div style={{marginTop: 3, marginLeft: 15, height: 20, borderLeft: "1px solid black", borderBottom: "1px solid black"}}></div>}
                {hasStornoFile && <div style={{marginTop: 3, marginLeft: 15, height: 20, borderLeft: "1px solid black", borderBottom: "1px solid black"}}></div>}
            </td>
            <td>
                {invoiceType}
                {hasSecondFile && <div>Datei 2</div>}
                {hasMahnungFile && <div>Mahnung</div>}
                {hasStornoFile && <div>Stornorechnung</div>}
            </td>
            <td>
                {invoiceDate}
            </td>
            <td>{anlageNum}</td>
            <td>{brutto}</td>
            <td className="text-center">
                {isDownloaded}
                {hasSecondFile && <div>{isDownloaded}</div>}
                {hasMahnungFile && <div>{UTILS.checkUncheckIcons(invoice.x_datum_download_mahnung !== "False")}</div>}
                {hasStornoFile && <div>{UTILS.checkUncheckIcons(invoice.x_datum_download_storno !== "False")}</div>}
            </td>
        </tr>
    )
}
export default InvoiceTableRow;